import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { ComponentProps } from '../../ReactComponents/ComponentProps.csharp';
import { LocalStorageAccessor } from '../../StorageAccessor/LocalStorageAccessor';
import { CookiesConsentViewModel } from './CookiesConsentViewModel.csharp';

interface CookiesConsentState {
    isVisible: boolean;
}

export class CookiesConsent extends React.Component<ComponentProps<CookiesConsentViewModel>, CookiesConsentState> {
    private readonly cookiesConsentSettingKey = 'areCookiesAccepted';

    constructor(props: ComponentProps<CookiesConsentViewModel>) {
        super(props);

        this.state = {
            isVisible: false
        };
    }

    componentDidMount() {
        const areCookiesAccepted = LocalStorageAccessor.getItem(this.cookiesConsentSettingKey);
        this.setState({
            isVisible: areCookiesAccepted === null
        });
    }

    acceptCookies() {
        this.setState({
            isVisible: false
        });

        LocalStorageAccessor.setItem(this.cookiesConsentSettingKey, 'true');
    }

    render() {
        const { message, header, policyLinkLabel, policyLinkUrl } = this.props.model;
        const { isVisible } = this.state;

        return (
            isVisible && (
                <div className="CookiesConsent">
                    <div className="CookiesConsent__Inner">
                        <div className="CookiesConsent__Content">
                            <div className="CookiesConsent__Header">{header}</div>
                            <div className="CookiesConsent__Message">{message}</div>
                        </div>
                        <div className="CookiesConsent__Buttons">
                            {policyLinkUrl && policyLinkLabel && (
                                <a href={policyLinkUrl} className="CookiesConsent__Policy">
                                    {policyLinkLabel}
                                </a>
                            )}
                            <button onClick={() => this.acceptCookies()} className="CookiesConsent__Close">
                                <span className="visuallyHidden">{getTranslation(keys['cookiesConsent.acceptButtonLabel'])}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )
        );
    }
}
